<template>
  <router-link
    :to="!isPurchasingInAppPurchase ? '/notification' : ''"
    class="navigation-notification-icon-section"
    :class="{
      'navigation-notification-icon-section--active': isDisplayNotificationIcon,
      'navigation-notification-icon-section--race': current === 'race',
      'navigation-notification-icon-section--current': current === 'notification',
      'navigation-notification-icon-section--is-sp': isSp,
    }"
  >
    <navigation-notification-icon-parts class="navigation-notification-icon-section__icon" />
    <span v-if="hasName" class="navigation-notification-icon-section__name">{{
      $tc('navigation.notice')
    }}</span>
  </router-link>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import NavigationNotificationIconParts from '@/components/common/GlobalNavigation/GlobalNavigationPane/parts/NavigationNotificationIconParts.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * グローバルナビゲーション: 通知リンクアイコンセクション
 */
export default defineComponent({
  name: 'NavigationNotificationSectionParts',
  components: {
    NavigationNotificationIconParts,
  },
  props: {
    hasName: {
      type: Boolean,
      default: false,
    },
    current: {
      type: String,
      default: '',
    },
    isSp: {
      type: Boolean,
      default: false,
    },
    /**
     * アプリ内課金購入処理実行中かどうか
     */
    isPurchasingInAppPurchase: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const notificationStore = StoreUtil.useStore('NotificationStore')
    const { isDisplayNotificationIcon } = notificationStore

    return {
      isDisplayNotificationIcon,
    }
  },
})
</script>

<style lang="scss" scoped>
.navigation-notification-icon-section {
  display: inline-flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 36px;
  height: 48px;
  color: $black;
  border-bottom: 2px solid transparent;

  &--is-sp {
    .navigation-notification-icon-section__icon {
      opacity: 1;
    }
  }

  &--current {
    border-bottom-color: $black;

    .navigation-notification-icon-section__icon,
    .navigation-notification-icon-section__name {
      opacity: 1;
    }
  }

  &--active {
    position: relative;

    &::after {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(2px, -11px);
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: $red;
      border: 2px solid $white;
    }
  }

  &__icon {
    color: $black;
    opacity: 0.3;
  }

  &__name {
    margin-top: 2px;
    font-size: 10px;
    color: $black;
    line-height: 1.4;
    white-space: nowrap;
    opacity: 0.75;
  }

  &--race {
    .navigation-notification-icon-section__icon {
      color: $white;
      opacity: 0.3;
    }

    .navigation-notification-icon-section__name {
      color: $white;
      opacity: 0.75;
    }
  }
}
</style>
